import { render, staticRenderFns } from "./DownloadExcel.vue?vue&type=template&id=5f624d26&scoped=true&"
import script from "./DownloadExcel.vue?vue&type=script&lang=js&"
export * from "./DownloadExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f624d26",
  null
  
)

export default component.exports